import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class HblPoNo extends TrackableEntity {
    id: number = 0;
    hblId: number = 0;
    poNo: string = '';
    skuNo: string = '';
    htsCode: string = '';
    description: string = '';
    styleNo: string = '';
    itemNo: string = '';
    shipQty: number = 0;
    kgs: number = 0;
    lbs: number = 0;
    cbm: number = 0;
    cKgs: number = 0;
    cft: number = 0;
    cLbs: number = 0;
    shipUnit: string = '';
    coo: string = '';
    uPrice: number = 0;
    pimsLinkUserId: string = '';
    pimsLinkId: number = 0;
    pimsLinkDate: string | null = null;
    pimsPoHdLinkId: number = 0;
    pimsPoDetLinkId: number = 0;
    cntrLinkId: number = 0;
    cntrId: number = 0;
    containerNo: string = '';
    orderQty: number = 0;
    orderUnit: string = '';
    state: string = '';
    oihblId: number = 0;
    aihblid: number = 0;

    // UI
    select: boolean = false;

    constructor(init?:Partial<HblPoNo>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'cntrId', 'containerNo', 'orderQty', 'orderUnit', 'state', 'oihblId', 'aihblid');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        let dicFieldMappings = HblPoNo.dicFieldMappings;

        switch (arg) {
            case 'aiHPoList':
                dicFieldMappings = HblPoNo.dicFieldMappings2;
              break;
            case 'ponoList':
                dicFieldMappings = HblPoNo.dicFieldMappings3;
              break;
          }
          
        return dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_OOHPONO' }),
        'poNo': new DBMappingInfo({ field: 'F_PONO', table: 'T_OOHPONO' }),
        'skuNo': new DBMappingInfo({ field: 'F_SKUNO', table: 'T_OOHPONO' }),
        'htsCode': new DBMappingInfo({ field: 'F_HTSCODE', table: 'T_OOHPONO' }),
        'coo': new DBMappingInfo({ field: 'F_COO', table: 'T_OOHPONO' }),
        'description': new DBMappingInfo({ field: 'F_DESCRIPTION', table: 'T_OOHPONO' }),
        'shipQty': new DBMappingInfo({ field: 'F_SHIPQTY', table: 'T_OOHPONO' }),
        'shipUnit': new DBMappingInfo({ field: 'F_SHIPUNIT', table: 'T_OOHPONO' }),
        'uPrice': new DBMappingInfo({ field: 'F_UPRICE', table: 'T_OOHPONO' }),
        'kgs': new DBMappingInfo({ field: 'F_KGS', table: 'T_OOHPONO' }),
        'cbm': new DBMappingInfo({ field: 'F_CBM', table: 'T_OOHPONO' }),
        'cntrLinkId': new DBMappingInfo({ field: 'F_CNTRLINKID', table: 'T_OOHPONO' }),
        'pimsPoHdLinkId': new DBMappingInfo({ field: 'F_PIMSPOHDLINKID', table: 'T_OOHPONO' }),
        'pimsPoDetLinkId': new DBMappingInfo({ field: 'F_PIMSPODETLINKID', table: 'T_OOHPONO' }),
        'hblId': new DBMappingInfo({ field: 'F_OOHBLID', table: 'T_OOHPONO' }),
        'lbs': new DBMappingInfo({ field: 'F_LBS', table: 'T_OOHPONO' }),
        'cft': new DBMappingInfo({ field: 'F_CFT', table: 'T_OOHPONO' }),
    };

    static dicFieldMappings2:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_AIHPONO' }),
        'hblId': new DBMappingInfo({ field: 'F_AIHBLID', table: 'T_AIHPONO' }),
        'poNo': new DBMappingInfo({ field: 'F_PONO', table: 'T_AIHPONO' }),
        'skuNo': new DBMappingInfo({ field: 'F_SKUNO', table: 'T_AIHPONO' }),
        'htsCode': new DBMappingInfo({ field: 'F_HTSCODE', table: 'T_AIHPONO' }),
        'coo': new DBMappingInfo({ field: 'F_COO', table: 'T_AIHPONO' }),
        'description': new DBMappingInfo({ field: 'F_description', table: 'T_AIHPONO' }),
        'shipQty': new DBMappingInfo({ field: 'F_ShipQty', table: 'T_AIHPONO' }),
        'shipUnit': new DBMappingInfo({ field: 'F_ShipUnit', table: 'T_AIHPONO' }),
        'uPrice': new DBMappingInfo({ field: 'F_UPRICE', table: 'T_AIHPONO' }),
        'kgs': new DBMappingInfo({ field: 'F_kgs', table: 'T_AIHPONO' }),
        'cKgs': new DBMappingInfo({ field: 'F_CKGS', table: 'T_AIHPONO' }),
        'lbs': new DBMappingInfo({ field: 'F_LBS', table: 'T_AIHPONO' }),
        'cLbs': new DBMappingInfo({ field: 'F_CLBS', table: 'T_AIHPONO' }),
        'pimsPoHdLinkId': new DBMappingInfo({ field: 'F_PimsPOHDLinkID', table: 'T_AIHPONO' }),
        'pimsPoDetLinkId': new DBMappingInfo({ field: 'F_PimsPODETLinkID', table: 'T_AIHPONO' }),

    };

    static dicFieldMappings3:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_AOHPONO' }),
        'hblId': new DBMappingInfo({ field: 'F_AOHBLID', table: 'T_AOHPONO' }),
        'poNo': new DBMappingInfo({ field: 'F_PONO', table: 'T_AOHPONO' }),
        'skuNo': new DBMappingInfo({ field: 'F_SKUNO', table: 'T_AOHPONO' }),
        'htsCode': new DBMappingInfo({ field: 'F_HTSCODE', table: 'T_AOHPONO' }),
        'coo': new DBMappingInfo({ field: 'F_COO', table: 'T_AOHPONO' }),
        'description': new DBMappingInfo({ field: 'F_DESCRIPTION', table: 'T_AOHPONO' }),
        'shipQty': new DBMappingInfo({ field: 'F_SHIPQTY', table: 'T_AOHPONO' }),
        'shipUnit': new DBMappingInfo({ field: 'F_SHIPUNIT', table: 'T_AOHPONO' }),
        'uPrice': new DBMappingInfo({ field: 'F_UPRICE', table: 'T_AOHPONO' }),
        'kgs': new DBMappingInfo({ field: 'F_KGS', table: 'T_AOHPONO' }),
        'lbs': new DBMappingInfo({ field: 'F_LBS', table: 'T_AOHPONO' }),
        'cKgs': new DBMappingInfo({ field: 'F_CKGS', table: 'T_AOHPONO' }),
        'cLbs': new DBMappingInfo({ field: 'F_CLBS', table: 'T_AOHPONO' }),
        'pimsPoHdLinkId': new DBMappingInfo({ field: 'F_PIMSPOHDLINKID', table: 'T_AOHPONO' }),
        'pimsPoDetLinkId': new DBMappingInfo({ field: 'F_PIMSPODETLINKID', table: 'T_AOHPONO' }),

    };

    static dicFieldMappings4:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_OIHPONO' }),
        'poNo': new DBMappingInfo({ field: 'F_PONO', table: 'T_OIHPONO' }),
        'skuNo': new DBMappingInfo({ field: 'F_SKUNO', table: 'T_OIHPONO' }),
        'htsCode': new DBMappingInfo({ field: 'F_HTSCODE', table: 'T_OIHPONO' }),
        'coo': new DBMappingInfo({ field: 'F_COO', table: 'T_OIHPONO' }),
        'description': new DBMappingInfo({ field: 'F_DESCRIPTION', table: 'T_OIHPONO' }),
        'shipQty': new DBMappingInfo({ field: 'F_SHIPQTY', table: 'T_OIHPONO' }),
        'shipUnit': new DBMappingInfo({ field: 'F_SHIPUNIT', table: 'T_OIHPONO' }),
        'uPrice': new DBMappingInfo({ field: 'F_UPRICE', table: 'T_OIHPONO' }),
        'kgs': new DBMappingInfo({ field: 'F_KGS', table: 'T_OIHPONO' }),
        'cbm': new DBMappingInfo({ field: 'F_CBM', table: 'T_OIHPONO' }),
        'cntrLinkId': new DBMappingInfo({ field: 'F_CNTRLINKID', table: 'T_OIHPONO' }),
        'pimsPoHdLinkId': new DBMappingInfo({ field: 'F_PIMSPOHDLINKID', table: 'T_OIHPONO' }),
        'pimsPoDetLinkId': new DBMappingInfo({ field: 'F_PIMSPODETLINKID', table: 'T_OIHPONO' }),
        'hblId': new DBMappingInfo({ field: 'F_OIHBLID', table: 'T_OIHPONO' }),
        'lbs': new DBMappingInfo({ field: 'F_LBS', table: 'T_OIHPONO' }),
        'cft': new DBMappingInfo({ field: 'F_CFT', table: 'T_OIHPONO' }),

    };
}
